import { useEffect, useRef } from 'react';
import { ItfObserverConfig } from './type';

export const useIntersectionObservers = (config: ItfObserverConfig, dependencies: any[] = [], isEditStatus = false) => {
    const observerRef = useRef<IntersectionObserver | null>(null);

    useEffect(() => {
        if (typeof window !== 'undefined' && !isEditStatus) {
            if (observerRef.current) {
                observerRef.current.disconnect();
                observerRef.current = null;
            }

            const { selectors, onEnter, onLeave, options } = config;
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            onEnter(entry.target);
                        } else if (onLeave) {
                            onLeave(entry.target);
                        }
                    });
                },
                {
                    root: null,
                    rootMargin: '-0.5% 0px',
                    threshold: 0.1,
                    ...options,
                },
            );
            selectors?.forEach((selector: string) => {
                const ele: HTMLElement | null = document.querySelector(selector);
                if (ele) observer.observe(ele);
            });

            return () => observer.disconnect();
        }
    }, [...dependencies, isEditStatus]);
};
